// extracted by mini-css-extract-plugin
export default {"checkbox":"ManyCheckboxInputStyled_checkbox__ljA+i"};